<template>
  <div v-if="showChatbot"></div>
</template>

<script>
import chatbotConfig from '@/config/chatbot.config.js'

export default {
  name: 'BotpressChatWidget',
  data() {
    return {
      chatbotConfig: chatbotConfig,
      botpressInitialized: false,
      checkInterval: null,
      scriptsLoaded: false
    }
  },
  methods: {
    loadBotpressScripts() {
      if (this.scriptsLoaded) {
        return Promise.resolve()
      }
      
      return new Promise((resolve, reject) => {
        // Charger le premier script (inject.js)
        const script1 = document.createElement('script')
        script1.src = 'https://cdn.botpress.cloud/webchat/v3.5/inject.js'
        script1.defer = true
        
        script1.onload = () => {
          // Charger le deuxième script (config)
          const script2 = document.createElement('script')
          script2.src = 'https://files.bpcontent.cloud/2025/12/17/08/20251217080622-7ATH0FOD.js'
          script2.defer = true
          
          script2.onload = () => {
            this.scriptsLoaded = true
            if (this.chatbotConfig.displayOptions.debug) {
              console.log('✅ Scripts Botpress chargés')
            }
            resolve()
          }
          
          script2.onerror = () => {
            console.error('❌ Erreur lors du chargement du script Botpress config')
            reject(new Error('Failed to load Botpress config script'))
          }
          
          document.body.appendChild(script2)
        }
        
        script1.onerror = () => {
          console.error('❌ Erreur lors du chargement du script Botpress inject')
          reject(new Error('Failed to load Botpress inject script'))
        }
        
        document.body.appendChild(script1)
      })
    },
    
    initializeBotpress() {
      // Vérifier régulièrement si l'objet Botpress est disponible
      this.checkInterval = setInterval(() => {
        if (window.botpress) {
          clearInterval(this.checkInterval)
          
          if (this.chatbotConfig.displayOptions.debug) {
            console.log('✅ Botpress disponible, initialisation...')
          }
          
          // Une fois initialisé, mettre à jour les données utilisateur avec la langue détectée
          window.botpress.on("webchat:initialized", () => {
            window.botpress.updateUser({
              data: { language: window.__bpLang || "fr" },
            })
            
            this.botpressInitialized = true
            
            if (this.chatbotConfig.displayOptions.debug) {
              console.log('[Lokmi] Botpress initialisé avec langue:', window.__bpLang)
              console.log('[Lokmi] Tenant actuel:', this.currentTenant ? this.currentTenant.slug : 'aucun')
            }
          })
        }
      }, 100)
    },
    
    showBot() {
      if (window.botpress && this.botpressInitialized) {
        window.botpress.sendEvent({ type: 'show' })
      }
    },
    
    hideBot() {
      if (window.botpress && this.botpressInitialized) {
        window.botpress.sendEvent({ type: 'hide' })
      }
    }
  },
  computed: {
    currentTenant() {
      return this.$store.state.company
    },
    showChatbot() {
      if (!this.currentTenant) {
        return false
      }
      
      // Si le chatbot est activé pour tous les tenants
      if (this.chatbotConfig.enableForAllTenants) {
        return true
      }
      
      // Si la liste des tenants autorisés est vide, désactiver le chatbot
      if (!this.chatbotConfig.allowedTenants || this.chatbotConfig.allowedTenants.length === 0) {
        return false
      }
      
      // Vérifier si le tenant actuel est dans la liste des tenants autorisés
      return this.chatbotConfig.allowedTenants.includes(this.currentTenant.slug) ||
             this.chatbotConfig.allowedTenants.includes(this.currentTenant.uuid) ||
             this.chatbotConfig.allowedTenants.includes(this.currentTenant.domain)
    }
  },
  watch: {
    showChatbot: {
      handler(newVal) {
        if (this.chatbotConfig.displayOptions.debug) {
          console.log('Chatbot autorisé?', newVal)
          const tenantSlug = this.currentTenant ? this.currentTenant.slug : 'inconnu'
          console.log('Tenant:', tenantSlug)
        }
        
        // Charger les scripts uniquement si le tenant est autorisé
        if (newVal && !this.scriptsLoaded) {
          if (this.chatbotConfig.displayOptions.debug) {
            console.log('🚀 Chargement des scripts Botpress...')
          }
          
          this.loadBotpressScripts()
            .then(() => {
              this.initializeBotpress()
            })
            .catch(error => {
              console.error('Erreur lors du chargement de Botpress:', error)
            })
        }
        
        // Afficher ou masquer le bot selon les permissions
        if (this.botpressInitialized) {
          if (newVal) {
            this.showBot()
          } else {
            this.hideBot()
          }
        }
      },
      immediate: true
    },
    
    currentTenant: {
      handler(newTenant) {
        if (newTenant && this.botpressInitialized) {
          // Mettre à jour le contexte utilisateur avec les infos du tenant
          if (window.botpress) {
            window.botpress.updateUser({
              data: { 
                language: window.__bpLang || "fr",
                tenantSlug: newTenant.slug,
                tenantUuid: newTenant.uuid
              },
            })
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    // Ne pas charger automatiquement, attendre la vérification des permissions
    // Les scripts seront chargés uniquement si showChatbot devient true
    if (this.chatbotConfig.displayOptions.debug) {
      console.log('📱 BotpressChatWidget monté, en attente des permissions...')
    }
  },
  beforeDestroy() {
    // Nettoyer l'intervalle
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  }
}
</script>

<style scoped>
/* Le chatbot est maintenant géré entièrement par Botpress */
/* Les styles sont définis dans le script Botpress et via les CSS variables */
</style>

